module.exports = __webpack_public_path__ + "img/luiz.ad8d795c.png";